<template>
  <div class="card border-0 card-with-shadow">
    <div class="card-header d-flex align-items-center justify-content-between p-primary bg-transparent">
      <h5 v-show="isFollowersEditable" class="card-title text-muted m-0">{{ $t('follower') }}
        ({{ followerData.total_followers }})</h5>
      <h5 v-show="!isFollowersEditable" class="card-title text-muted m-0">{{ $t('edit_follower') }}</h5>
      <div>

        <a href="#" v-show="!isFollowersEditable" class="text-muted" @click.prevent="showFollowersHidetable">
          <app-icon stroke-width="1" name="x-square"/>
        </a>
        <a href="#" v-show="!isFollowersEditable" class="text-muted" @click.prevent="showFollowersUpdate">
          <app-icon stroke-width="1" name="check-square"/>
        </a>

        <a href="#" v-show="isFollowersEditable" class="text-muted" @click.prevent="showFollowersEditable">
          <app-icon stroke-width="1" name="edit"/>
        </a>
      </div>
    </div>
    <div class="card-body">

      <div v-show="isFollowersEditable">
        <div v-if="followerData.followers">
          <template v-if="followerData.followers.length">
            <div class="media d-flex align-items-center"
                 :class="{'mb-3': followerData.followers.length > 1 && index !== followerData.followers.length - 1}"
                 v-for="(follower, index) in followerData.followers"
                 :key="index" v-if="index < 3">

              <app-avatar v-if="follower.person"
                          :title="follower.person.name"
                          class="mr-2"
                          avatar-class="avatars-w-40"
                          :img="follower.person.profile_picture ?
                                urlGenerator(follower.person.profile_picture.path) :
                                follower.person.profile_picture"
              />

              <div class="media-body" v-if="follower.person">
                {{ follower.person.name }}
                <p class="text-muted font-size-90 mb-0">
                  {{ follower.person.email.value }}
                </p>
              </div>
            </div>
          </template>
          <template v-else>
            <p class="text-muted">{{ $t('no_person_linked_yet') }}</p>
            <a href="#" class="font-size-90" @click.prevent="showFollowersEditable">
              {{ $t('link_person_as_organization') }}
            </a>
          </template>
          <div class="d-flex justify-content-center" v-if="followerData.followers.length > 3">
            <button type="button" class="btn btn-secondary" @click.prevent="viewAll()">
              {{ $t('view_all') }}
            </button>
          </div>
        </div>
      </div>


      <div v-show="!isFollowersEditable">
        <div class="form-group"
             :class="{'mb-3': followerData.followers.length > 1 && index !== followerData.followers.length - 1}"
             v-for="(follower, index) in followerData.followers"
             :key="index">
          <div class="form-row align-items-center">
            <div class="col-11">
              <app-input type="select"
                         :placeholder="$t('choose_one')"
                         list-value-field='name'
                         :list="peopleList"
                         v-model="follower.person_id"
              />
              <small class="text-danger" v-if="Object.keys(errors).length">
                <template v-for="validate in Object.keys(errors)">
                  <template v-if="validate.slice(10) == index">
                    <template v-for="messageData in errors[validate]">{{ messageData }}</template>
                  </template>
                </template>
              </small>
            </div>
            <div class="col-1">
              <a href="#" class="text-muted" @click.prevent="removeFollower(index)">
                <app-icon width="20" stroke-width="1" name="trash"/>
              </a>
            </div>
          </div>
        </div>
        <a href="#" @click.prevent="addMoreFollower">
          + add more
        </a>
      </div>

      <app-common-all-follower
          v-if="viewAllModal"
          :follower-data="followerUrl"
          @close-modal="closedViewModal"
      />
    </div>
  </div>
</template>

<script>
import {FormMixin} from "@core/mixins/form/FormMixin.js";
import {urlGenerator} from "@app/Helpers/helpers";

export default {
  name: "FollowerOrganization",
  props: ['followerData', 'quickView', 'peopleList'],
  mixins: [FormMixin],
  data() {
    return {
      urlGenerator,
      isFollowersEditable: true,
      viewAllModal: false,
      errors: [],
      followerUrl:'',
    }
  },

  methods: {
    addMoreFollower() {
      this.followerData.followers.push({
        person_id: ''
      });
    },
    removeFollower(index) {
      this.followerData.followers.splice(index, 1)
    },
    showFollowersEditable() {
      this.isFollowersEditable = false;

    },
    showFollowersHidetable() {
      let followerList = this.followerData.followers.filter((item) => {
        if (item.person_id) {
          return true;
        }
      })
      this.followerData.followers = followerList;
      this.isFollowersEditable = true;
    },
    showFollowersUpdate() {
      let followerFlatArray = this.followerData.followers.map(function (obj) {
        return obj.person_id;
      });
        let arr = this.followerData.followers.map((data)=> data.person_id);
        if(new Set(arr).size == arr.length){
            this.axiosPost({
                url: `crm/organizations/followers/${this.followerData.id}`,
                data: {'person_id': followerFlatArray}
            }).then(response => {
                this.$toastr.s(response.data.message);
                this.isFollowersEditable = true;
                this.errors = [];
                this.$emit('update-request');
            }).catch((error) => {
                this.errors = error.response.data.errors;
            })
        }else{
            this.$toastr.i(this.$t('follower_duplicate'),'Duplicate');
        }
    },
    organizationsFollower(){
      this.followerUrl = `crm/organizations/${this.followerData.id}/followers`;
    },
    viewAll() {
      this.quickView ? this.$emit("viewAllFollower", this.followerUrl) : this.viewAllModal = true;
    },
    closedViewModal() {
      this.viewAllModal = false;
    },
  },
  created() {
      this.organizationsFollower();
  }

}
</script>
